module.exports = JSON.parse('{"languageSwitcher":{"label":"Limbă"},"close":"Închide","pageTitle":"Anul Nou 2027 — Nimic de prisos! | NL International"}')